import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";

import {
  requestCheckIsModelDeployedStatus,
  requestDeployModelStatus,
  requestDeleteServableModelStatus,
  requestDeleteMachineModelConnectionStatus,
  requestCheckServableModelsLimitStatus,
  requestServableModelsStatus,
  requestUndeployModelStatus,
} from "../effects/modelDeployment-effects";

const initialState = {
  /**@type {boolean} */
  loading: false,

  /**@type {boolean} */
  isModelDeployed: false,

  /**@type {boolean} */
  isModelDeploying: false,

  /**@type {boolean} */
  isModelDeleting: false,

  // /**@type {boolean} */
  // isModelUndeploying: false,

  /**@type {boolean} */
  isModelExsit: false,

  /**@type {boolean} */
  limitExceeded: false,

  /**@type {boolean} */
  isModelConnectedToMonitor: false,

  /**@type {Array} */
  servableModels: [],

  /**@type {string} */
  modelId: "",

  /**@type {string} */
  modelName: "",

  /**@type {string} */
  datasetId: "",

  /**@type {string} */
  type: "",

  /**@type {Number} */
  maxAllowedServableModels: 0,

  /**@type {Number} */
  deployedModels: 0,

  /**@type {string} */
  deploymentError: "",
};

const modelDeploymentSlice = createSlice({
  name: slices.modelDeployment,
  initialState,
  reducers: {
    resetModelDeployment: (state, action) => initialState,
    checkLimit: (state, { payload }) => (state.limitExceeded = payload.limitReached),
  },
  extraReducers: {
    ...requestCheckIsModelDeployedStatus,
    ...requestDeployModelStatus,
    ...requestDeleteServableModelStatus,
    ...requestDeleteMachineModelConnectionStatus,
    ...requestCheckServableModelsLimitStatus,
    ...requestServableModelsStatus,
    ...requestUndeployModelStatus,
  },
});

const { actions, reducer } = modelDeploymentSlice;

export const { resetModelDeployment, checkLimit } = actions;

export default reducer;
